import qs from 'qs';
import { API } from '../../api';
import { axiosInstance } from '../../axios';
import { ILoginResponse } from '@/shared/api/auth/login/types';
import { HEADERS } from '@/shared/api/headers';

interface IParams {
  code: string;
  code_verifier: string;
  redirect_url: string;
  lang: string;
}

export const login = async ({ lang, ...body }: IParams) => {
  const result = await axiosInstance.post<ILoginResponse>(
    API.login,
    qs.stringify(body),
    {
      params: { lang },
      headers: {
        ...HEADERS.contentTypeUrlencoded,
      },
    }
  );

  return result.data;
};
